import {
    EnvironmentProviders,
    inject,
    Provider,
    provideEnvironmentInitializer,
} from '@angular/core';
import { NavigationService } from './lib/services/navigation/navigation.service';
import { ZopUxLayoutLibConfig } from './lib/services/config/config.types';
import { ZOP_UX_LAYOUT_LIB_CONFIG } from './lib/const/zop-ux-layout.token';
import { MediaWatcherService } from './lib/services/media-watcher/media-watcher.service';
import { PlatformService } from './lib/services/platform/platform.service';

/**
 * Zop UX Layout Config Provider
 */
export const provideZopUxLayoutCore = (
    config: ZopUxLayoutLibConfig
): Array<Provider | EnvironmentProviders> => {
    // Base providers
    const providers: Array<Provider | EnvironmentProviders> = [
        {
            provide: ZOP_UX_LAYOUT_LIB_CONFIG,
            useValue: config,
        },
        provideEnvironmentInitializer(() => inject(MediaWatcherService)),
        provideEnvironmentInitializer(() => inject(PlatformService)),
        provideEnvironmentInitializer(() => inject(NavigationService)),
    ];

    // Return the providers
    return providers;
};
